<template>
  <div class="green lighten-4">
    <v-container style="max-width: 1800px">
      <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/reports/overall/overview`"
        active-class="white--text primary"
        outlined
        elevation="0"
        >Overview</v-btn
      >
      <!-- <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/reports/overall/compare`"
        active-class="white--text primary"
        outlined
        elevation="0"
        >เปรียบเทียบระหว่างตลาด</v-btn
      > -->
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    type: String
  }
};
</script>

<style lang="scss" scoped>
.tool-bar{
  background-color: rgb(233,249,238);
  border: 1px solid rgb(221,242,228);
}
</style>
